<app-terminal-overlay
    [title]="title()"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_A_PRODUCT_BOX' | translate }}"
    [measurementType]="activity()?.measurementType"
    icon="fa-boxes-stacked"
    (closeRequested)="onCloseRequested()"
>
    <app-product-box [activity]="activity()" (productBoxUpdated)="onProductBoxUpdated($event)" />

    <app-manual-flow-footer
        data-footer
        (cancel)="onCloseRequested()"
        (next)="onSelectionComplete()"
        [nextEnabled]="areProductRegistrationsValid()"
        [cancelEnabled]="true"
    />
</app-terminal-overlay>
